import { useStore } from '@tanstack/react-store';
import React from 'react';
import { data } from '~/data/basic';
import colors from '~/data/colors';
import { langStore } from '~/store/langStore';
import { WemsicalIcon } from './wemsical-logo';

const About: React.FC = () => {
  const locale = useStore(langStore, s => s);

  return (
    <>
      <div
        className="bg-about flex h-[600px] flex-col bg-cover bg-center bg-no-repeat text-black"
        style={{

          backgroundColor: colors.beige,
          // clipPath: 'polygon(0 0, 69% 0, 100% 17%, 100% 100%, 25% 100%, 0 89%)',
        }}
      >
        <div className="flex w-full flex-col p-6 text-left md:p-24">
          <h2 className="text-center text-xl font-bold text-black md:text-3xl">
            {data.homepage.about[locale]}
          </h2>
          <p className="mx-auto
          mt-2 w-[90%]
          text-sm
          leading-relaxed font-medium tracking-wide sm:mt-6 md:text-lg"
          >
            {data.homepage.about_desc[locale]}
          </p>
        </div>
        <div className="mx-auto mt-2 flex w-4/5 flex-wrap justify-center gap-12 md:items-end md:justify-end-safe">
          <img src="/malom-piros.svg" alt="Malom Logo" className="h-4 sm:h-6 md:h-10" />
          {/* <img src="/wemsical-piros.svg" alt="Wemsical Logo" className="h-6 md:h-10" /> */}
          <WemsicalIcon className="h-4 text-[#903c1d] sm:h-6 md:h-10" />
        </div>
      </div>
    </>
  );
};

export default About;
